import { jsx as _jsx } from "nativewind/jsx-runtime";
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import styled from 'styled-components/native';
export default function EmptyViewText({ children }) {
    return (_jsx(Container, { children: _jsx(NoResultText, { children: children }) }));
}
const Container = styled.View `
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding-top: 60px;
  padding-bottom: 60px;
`;
const NoResultText = styled.Text `
  font-size: 14px;
  font-family: ${() => font.pretendardMedium};
  color: ${() => color.gray50};
`;
